<template>
  <div>
    <NumberFormGroup
        :value="value.limit"
        name="limit"
        label="Limit"
        :error="(errors.limit || [])[0]"
        help-text="The total number of items to display."
        @input="emit('limit', $event)"
    />

    <NumberFormGroup
        :value="value.page_size"
        name="page_size"
        label="Page Size"
        :error="(errors.page_size || [])[0]"
        help-text="The number of items to display before showing the 'Load more' button."
        @input="emit('page_size', $event)"
    />
  </div>
</template>

<script>
import NumberFormGroup from '@/vendor/forms/FormGroups/Block/Number'

export default {
  components: {NumberFormGroup},

  props: {
    value: {
      required: true
    },

    errors: {
      required: true
    }
  },

  methods: {
    emit(key, value) {
      this.$emit('input', {...this.value, [key]: value})
    },
  }
}
</script>
